import { AUTO, Game, Scale, type Types } from 'phaser';
import type { TurboDuelConfig } from '../domain/raceLevels';
import { TurboDuelScene } from './TurboDuelScene';

export function startTurboDuelGame(parent: string, gameId: string, raceConfig: TurboDuelConfig, restartEnabled = true): Game {
  const config: Types.Core.GameConfig = {
    type: AUTO,
    width: 1280,
    height: 720,
    parent,
    backgroundColor: '#0b2432',
    scale: { mode: Scale.ENVELOP, autoCenter: Scale.CENTER_BOTH },
    scene: [new TurboDuelScene(raceConfig, gameId, restartEnabled)],
  };
  return new Game(config);
}
